// extracted by mini-css-extract-plugin
var _1 = "#000";
var _2 = "1260px";
var _3 = "1020px";
var _4 = "668px";
var _5 = "1550px";
var _6 = "1140px";
var _7 = "940px";
var _8 = "100%";
var _9 = "15px";
var _a = "620px";
var _b = "pfx-CommunityShareModal-module__copy-row--zzMs5";
var _c = "pfx-CommunityShareModal-module__copy-snippet--V5s9s";
var _d = "pfx-CommunityShareModal-module__copy-snippet-btn--xf9nA";
var _e = "#f53535";
var _f = "rgba(0,0,0,.2)";
var _10 = "rgba(255,255,255,.38)";
var _11 = ".38";
var _12 = "rgba(255,255,255,.2)";
var _13 = "#0025ff";
var _14 = "pfx-CommunityShareModal-module__glitch-anim--a3aFH";
var _15 = "pfx-CommunityShareModal-module__glitch-anim-2--JbVVq";
var _16 = "#f60";
var _17 = "#41ead4";
var _18 = "#2cdd78";
var _19 = "#66ab23";
var _1a = "#f5f5f5";
var _1b = "#c3c3c3";
var _1c = "#ececec";
var _1d = "#252525";
var _1e = "#272727";
var _1f = "#c6c6c5";
var _20 = "#333";
var _21 = "#3c3c3c";
var _22 = "#9c9b9b";
var _23 = "#8c8c8c";
var _24 = "#6f6f6e";
var _25 = "#3c3c3b";
var _26 = "#373737";
var _27 = "#6a6a69";
var _28 = "#6f6f6f";
var _29 = "#9f9e9e";
var _2a = "#282828";
var _2b = "#828181";
var _2c = "#1d1d1d";
var _2d = "#979797";
var _2e = "#9c9b9b";
var _2f = "#a7a7a6";
var _30 = "#c6c6c5";
var _31 = "#d8d8d7";
var _32 = "#dddddc";
var _33 = "72px";
var _34 = "40px";
var _35 = "36px";
var _36 = "25px";
var _37 = "18px";
var _38 = "13px";
var _39 = "pfx-CommunityShareModal-module__header-title--YCTAE";
var _3a = "#0025ff";
var _3b = "rgba(255,255,255,.12)";
var _3c = "#6535f5";
var _3d = "2px";
var _3e = "56px";
var _3f = "56px";
var _40 = "#41ead4";
var _41 = "#f60";
var _42 = "#f83600";
var _43 = "#881f00";
var _44 = "18px";
var _45 = "15px";
var _46 = "red";
var _47 = "pfx-CommunityShareModal-module__share-screen-title-username--z6YrJ";
var _48 = "pfx-CommunityShareModal-module__share-sheet--Q29UZ";
var _49 = "pfx-CommunityShareModal-module__share-sheet-copy-button--JUczT";
var _4a = "pfx-CommunityShareModal-module__share-sheet-header--pXCcn";
var _4b = "pfx-CommunityShareModal-module__share-sheet-input--KHhvE";
var _4c = "pfx-CommunityShareModal-module__share-sheet-label--MYvBq";
var _4d = "pfx-CommunityShareModal-module__share-sheet-social--TP9my";
var _4e = "pfx-CommunityShareModal-module__share-sheet-social-icon--g_1ea";
var _4f = "pfx-CommunityShareModal-module__share-sheet-textarea--YaU9u";
var _50 = "pfx-CommunityShareModal-module__social-media-icon--hrcQW";
var _51 = "13px";
var _52 = "rgba(255,255,255,.07)";
var _53 = "#35465c";
var _54 = "#55acee";
var _55 = "#fff";
var _56 = "#ffce36";
var _57 = "#ffcd00";
var _58 = "red";
export { _1 as "black", _2 as "breakLarge", _3 as "breakMedium", _4 as "breakSmall", _5 as "breakVLarge", _6 as "containerLarge", _7 as "containerMedium", _8 as "containerMobile", _9 as "containerPaddingMobile", _a as "containerSmall", _b as "copyRow", _c as "copySnippet", _d as "copySnippetBtn", _e as "danger", _f as "darkElement", _10 as "disabled", _11 as "disabledOpacity", _12 as "extraLightElement", _13 as "facebook", _14 as "glitchAnim", _15 as "glitchAnim2", _16 as "google", _17 as "green", _18 as "green2", _19 as "greenColor", _1a as "grey1", _1b as "grey10", _1c as "grey2", _1d as "grey25", _1e as "grey27", _1f as "grey3", _20 as "grey33", _21 as "grey3C", _22 as "grey4", _23 as "grey41", _24 as "grey5", _25 as "grey6", _26 as "grey61", _27 as "grey6A", _28 as "grey6F", _29 as "grey7", _2a as "grey8", _2b as "grey82", _2c as "grey9", _2d as "grey97", _2e as "grey9C", _2f as "greyA7", _30 as "greyC6", _31 as "greyD8", _32 as "greyDd", _33 as "header1", _34 as "header2", _35 as "header3", _36 as "header4", _37 as "header5", _38 as "header6", _39 as "headerTitle", _3a as "klein", _3b as "lightElement", _3c as "lilac", _3d as "menuBorder", _3e as "menuHeight", _3f as "menuMobileHeight", _40 as "ocean", _41 as "orange", _42 as "orange2", _43 as "orangeDark", _44 as "paragraph", _45 as "paragraphSmall", _46 as "red", _47 as "shareScreenTitleUsername", _48 as "shareSheet", _49 as "shareSheetCopyButton", _4a as "shareSheetHeader", _4b as "shareSheetInput", _4c as "shareSheetLabel", _4d as "shareSheetSocial", _4e as "shareSheetSocialIcon", _4f as "shareSheetTextarea", _50 as "socialMediaIcon", _51 as "subHeaderSmall", _52 as "subtleLightElement", _53 as "tumblr", _54 as "twitter", _55 as "white", _56 as "yellow", _57 as "yellowDeep", _58 as "youtube" }
